import { render, staticRenderFns } from "./DetailsArrowIcon.vue?vue&type=template&id=10994216&"
import script from "./DetailsArrowIcon.vue?vue&type=script&lang=js&"
export * from "./DetailsArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports